var React = require('react');

function ArrowPointToRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M5.4964823,5.49318584 L1.19809735,9.79143805 C0.924668142,10.065 0.481349558,10.065 0.208053097,9.79143805 C-0.0652654867,9.51811947 -0.0652654867,9.07482301 0.208053097,8.80152655 L4.01146018,4.99823009 L0.208163717,1.19506637 C-0.0651548673,0.921637168 -0.0651548673,0.478384956 0.208163717,0.205066372 C0.481482301,-0.0683628319 0.924778761,-0.0683628319 1.19820796,0.205066372 L5.49659292,4.50338496 C5.63325221,4.64011062 5.70150442,4.81911504 5.70150442,4.99820796 C5.70150442,5.17738938 5.63311947,5.35652655 5.4964823,5.49318584 Z"}));
}

ArrowPointToRight.defaultProps = {"viewBox":"0 0 6 10"};

module.exports = ArrowPointToRight;

ArrowPointToRight.default = ArrowPointToRight;
